import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';

import ZendeskHelp from './ZendeskHelp';

const ModalTitleZendeskHelp = ({ message, article }) => (
  <Fragment>
    <FormattedMessage {...message} />
    <ZendeskHelp article={article} />
  </Fragment>
);
ModalTitleZendeskHelp.propTypes = {
  message: PropTypes.shape({ id: PropTypes.string.isRequired }).isRequired,
  article: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  intl: intlShape.isRequired,
};
ModalTitleZendeskHelp.defaultProps = {
  article: '',
};

export default injectIntl(ModalTitleZendeskHelp);
